<script setup lang="ts">
import SecureImageSlider from "@/core/components/secure-image/SecureImageSlider.vue";
import SecureImage from "@/core/components/secure-image/SecureImage.vue";
import {ConsumerCart} from "@/core/http/resources/ConsumerCartResource";
import {ProductSummary} from "@/product/interfaces/ProductSummary";
import {Checkbox} from "@/core/components/ui/checkbox";

const props = defineProps<{
    cart: ConsumerCart;
    selectedProducts: ProductSummary[];
}>();

const emits = defineEmits<{
    (e: 'select', product: ProductSummary): void;
}>();

/**
 * Handle the selection of a product in the cart.
 */
const handleSelected = ({id, name, code}: { id: string; name: string; code: string | null }) => {
    emits('select', {
        id: Number(id),
        name,
        cip: code ?? '',
        id_7: '',
    });
};

/**
 * Determine whether a given product ID has been selected in the consumer products.
 */
const selected = (productId: string) => {
    return props.selectedProducts.some(product => product.id === Number(productId));
};
</script>

<template>
  <div class="flex flex-row">
    <div
      v-if="cart.prescription_urls?.length"
      class="flex w-1/2"
    >
      <secure-image
        v-if="cart.prescription_urls?.length === 1"
        :urls="cart.prescription_urls[0]"
        :size="80"
        :ratio="0.7"
      />
      <secure-image-slider
        v-else
        :images="cart.prescription_urls"
        :size="80"
        :ratio="0.7"
      />
    </div>

    <div
      class="flex flex-col p-4 bg-white rounded-lg shadow-md flex-1 self-start"
    >
      <div class="flex justify-between items-center">
        <h3 v-if="cart.professional?.name">
          Dr. {{ cart.professional.name }}
        </h3>
        <div>
          <p>
            {{ $filters.date(cart.date, 'dayOnly') }}
          </p>
          <p v-if="!cart.has_prescription">
            Hors ordonnance
          </p>
        </div>
      </div>
      <div class="flex flex-col gap-3 flex-1">
        <div
          v-for="(product, index) in cart.products.filter(_product => _product.id !== '0')"
          :key="index"
        >
          <div class="flex items-center gap-x-2">
            <Checkbox
              :id="product.id" :model-value="selected(product.id)"
              @update:model-value="handleSelected(product)"
            />
            <label :for="product.id">{{ product.quantity }}x {{ product.name }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
